import { CalendarEventType } from '../../types';
import { calendarTexts } from '../text';

export const eventTypeLabels = {
    [CalendarEventType.HOLIDAY_AND_SPECIAL_EVENT]: calendarTexts.typeLabels.holidays,
    [CalendarEventType.SCHOOL_HOLIDAY]: calendarTexts.typeLabels.schoolHolidays,
    [CalendarEventType.OTHER]: calendarTexts.typeLabels.others,
};
